<template>
  <div class="time-container">
    <!--选中的日期-->
    <p class="header-time">
      {{ selectedDay.value.substring(5, 7) }}月{{
        selectedDay.value.substring(8, 10)
      }}日
    </p>
    <div class="time-table">
      <!--左箭头-->
      <div id="time-table-left-arrow" @click="onRollPage(-1)" class="item">
        <span
          class="arrow left"
          :class="{ 'arrow disabled-left': page === 1 }"
        ></span>
      </div>
      <div v-for="(day, index) in currentShowList" class="item">
        <p
          class="week"
          :class="{ 'text-selected': selectedDay.value === day.value }"
        >
          {{ day.weekDay }}
        </p>
        <label
          @click="select(day)"
          :class="{ selected: selectedDay.value === day.value }"
          :id="'time-table-select-' + index"
        >
          <div :class="day.isToday ? 'today' : ''" class="day">
            {{ day.monthDay }}
          </div>
        </label>
      </div>
      <!--右箭头-->
      <div id="time-table-right-arrow" @click="onRollPage(1)" class="item">
        <span
          class="arrow right"
          :class="{
            'arrow disabled-right': page === Math.ceil(dateList.length / 5),
          }"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
import registerService from 'register.service'
const commitDate = function (vm, dateObj) {
  vm.$store.commit('updateParam', {
    namespace: 'register',
    date: dateObj
  });
}
export default {
  props: {
    areaId: String,
    deptId: String,
  },
  mounted () {
    var params = this.$store.state.paramModule.param.register;
    if (params.date) {
      this.selectedDay = params.date;
    } else {
      this.selectedDay = {
        value: new Date().format('yyyy-MM-dd'),
        weekDay: this.$utils.getWeekDay(new Date())
      }
      commitDate(this, this.selectedDay)
    }
    this.loadTimeTable();
  },

  data () {
    return {
      selectedDay: { value: '', weekDay: '' },
      page: 1,
      dateList: [],
      isInCity: false
    }
  },
  computed: {
    currentShowList () {
      const page = this.page
      return this.dateList.slice((page - 1) * 5, page * 5)
    },
  },
  methods: {
    //加载可用时段
    loadTimeTable () {
      var requestParams = {
        areaId: this.areaId,
        deptId: this.deptId
      }
      registerService.loadTimeTable(requestParams).then((res) => {
        if (res.resultCode !== "1") {
          this.$utils.alert(res.resultMsg);
          return;
        }
        var tables = res.data || [];
        const utils = this.$utils;
        const today = new Date();
        for (let i = 0, length = tables.length; i < length; i++) {
          const date = new Date(tables[i])
          const isToday = (date.getDate() === today.getDate()) && (date.getMonth() === today.getMonth())
          const timeObj = {
            weekDay: utils.getWeekDay(date),
            isToday: isToday,
            monthDay: isToday ? '今' : date.getDate(),
            value: date.format('yyyy-MM-dd')
          };
          this.dateList.push(timeObj)
          if (this.selectedDay.value === date.format('yyyy-MM-dd')) {
            this.isInCity = true
            this.$emit('change', timeObj)
          }
        }

        //判断市内、市外挂号
        if (this.isInCity === false) {
          this.selectedDay = this.dateList[0];
          commitDate(this, this.dateList[0]);
          this.$emit('change', this.dateList[0]);
        }
      })
    },
    // 翻页
    onRollPage (next) {
      const totalPage = Math.ceil(this.dateList.length / 5)
      if (this.page + next > totalPage || this.page + next === 0) {
        return
      }
      this.page += next
      const nextPageTemp = this.dateList[(this.page - 1) * 5]
      this.selectedDay = nextPageTemp
      commitDate(this, nextPageTemp)
      this.$emit('change', nextPageTemp)
    },
    //选择日期
    select: function (day) {
      this.selectedDay = day;
      commitDate(this, day);
      this.$emit('change', day);
    }

  }
}
</script>
<style lang="scss">
@import "../../static/sass/variable.scss";
.time-container {
  width: 100%;
  background-color: #ffffff;
  .day {
    text-align: center;
    color: #222;
  }
  .header-time {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 10px;
    margin-right: 10px;
    border-bottom: 1px solid #e9e9e9;
    color: $main-style-color;
    font-size: 16px;
  }
  .week {
    font-size: 14px;
    text-align: center;
    color: #777;
    margin-bottom: 10px;
  }
  .today {
    color: red;
  }
  .arrow {
    height: 30px;
    width: 30px;
    display: inline-block;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    &.left {
      background-image: url(../../static/img/btn-left.png);
    }
    &.disabled-left {
      background-image: url(../../static/img/btn-left-m.png);
    }
    &.right {
      background-image: url(../../static/img/btn-right.png);
    }
    &.disabled-right {
      background-image: url(../../static/img/btn-right-m.png);
    }
  }
}

.time-table {
  margin-top: 10px;
  height: 80px;
  width: 100%;
  display: table;
  padding-bottom: 0.5rem;
  .item {
    position: relative;
    display: table-cell;
    width: 14.2%;
    text-align: center;
    vertical-align: bottom;
  }
  label {
    height: 40px;
    width: 40px;
    line-height: 40px;
    display: inline-block;
    box-sizing: border-box;
  }
  .selected {
    background-color: $main-style-color;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    color: #fff;
    .day {
      font-size: 0.45rem;
      color: #fff;
    }
    .week {
      color: #fff;
    }
  }
  .text-selected {
    color: $main-style-color;
  }
}
</style>



// WEBPACK FOOTER //
// TimeTable.vue?40c99197